// extracted by mini-css-extract-plugin
export default {"body":"LegacyDialogBody_body__ufhN8"};